import { render, staticRenderFns } from "./cv8.vue?vue&type=template&id=6cbe396a&scoped=true&"
import script from "./cv8.vue?vue&type=script&lang=js&"
export * from "./cv8.vue?vue&type=script&lang=js&"
import style0 from "./cv8.vue?vue&type=style&index=0&id=6cbe396a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe396a",
  null
  
)

export default component.exports